import React, { useState, useEffect, useCallback} from 'react';
import { faTimes, faCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {Modal, Button} from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
const ErrorModal = (props) => {
    const { t } = useTranslation();
    let show = props.show;
    
    let icon, iconColor, modaltitle;
   
    function handleChange(){
       props.onChange (false);
    }
    if(props.estatus === true) {
        icon = faTimes;
        iconColor = 'red';
        modaltitle = t('modal.errorTitle');
    } else {
        icon = faCheck;
        iconColor = 'red';
        modaltitle = t('modal.successTitle');
    }
    return(
        <div>
            <Modal show={show} onHide = {handleChange}>
                <Modal.Header closeButton>
                    <Modal.Title>
                    <FontAwesomeIcon icon={icon} color={iconColor} />
                        &nbsp;{modaltitle}</Modal.Title>
                </Modal.Header>
                    <Modal.Body>{props.message}</Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleChange}>{t('actions.close')}</Button>
                </Modal.Footer>
            </Modal>
        </div>
        
    );
    
}
export default ErrorModal;